import API_BASE_URL from '../config/api';

/**
 * Organizer API Service
 * Handles all organizer-specific API calls
 */

/**
 * Get authentication token from localStorage
 */
function getAuthToken() {
  return localStorage.getItem('authToken');
}

/**
 * Get all competitions for organizer (including archived)
 */
export async function getOrganizerCompetitions() {
  const token = getAuthToken();
  
  const response = await fetch(`${API_BASE_URL}/organizer/competitions`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to fetch competitions');
  }

  return response.json();
}

/**
 * Create a new competition
 */
export async function createCompetition(competitionData) {
  const token = getAuthToken();
  
  const response = await fetch(`${API_BASE_URL}/organizer/competitions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(competitionData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create competition');
  }

  return response.json();
}

/**
 * Update an existing competition
 */
export async function updateCompetition(competitionId, updates) {
  const token = getAuthToken();
  
  const response = await fetch(`${API_BASE_URL}/organizer/competitions/${competitionId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to update competition');
  }

  return response.json();
}

/**
 * Create a new team in a competition
 */
export async function createTeam(competitionId, teamData) {
  const token = getAuthToken();
  
  const response = await fetch(`${API_BASE_URL}/organizer/competitions/${competitionId}/teams`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(teamData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create team');
  }

  return response.json();
}

/**
 * List teams in a competition
 */
export async function listTeams(competitionId, divisionId = null) {
  const token = getAuthToken();
  
  let url = `${API_BASE_URL}/organizer/competitions/${competitionId}/teams`;
  if (divisionId) {
    url += `?divisionId=${encodeURIComponent(divisionId)}`;
  }
  
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to list teams');
  }

  return response.json();
}

/**
 * Archive or unarchive a competition
 */
export async function archiveCompetition(competitionId, archived) {
  const token = getAuthToken();
  
  const response = await fetch(`${API_BASE_URL}/organizer/competitions/${competitionId}/archive`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ archived }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to archive competition');
  }

  return response.json();
}
